import React from 'react';
import { Input } from '@ais-ui/ui-core';


interface AngleInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'min' | 'max' | 'onChange'> {
  onChange: (value: number | string) => void;
}

export const AngleInput: React.FC<AngleInputProps> = ({ onChange, ...props }) => {
  return (
    <Input
      type="number"
      min={0}
      max={359}
      {...props}
      // onChange={onChange}
      onChange={(e) => {
        const value = e.target.value;
        if (!value) {
          onChange('');
        } else {
          const numberValue = parseFloat(value);

          if (isNaN(numberValue)) {
            onChange('');
            return;
          }

          if (numberValue < 0) {
            onChange(0);
            return;
          }

          if (numberValue > 359) {
            onChange(359);
            return;
          }

          onChange(numberValue);
        }
      }}
    />
  );
};
